import { render, staticRenderFns } from "./publicResources.vue?vue&type=template&id=9c6b4746&scoped=true&"
import script from "./publicResources.vue?vue&type=script&lang=js&"
export * from "./publicResources.vue?vue&type=script&lang=js&"
import style0 from "./publicResources.vue?vue&type=style&index=0&id=9c6b4746&prod&scoped=true&lang=css&"
import style1 from "./publicResources.vue?vue&type=style&index=1&id=9c6b4746&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b4746",
  null
  
)

export default component.exports